import { IActionDocumentsRequest } from '../store/documents/types'
import axiosInstance from './axios'
import { IPaginator } from '../store/root.types'
import { AxiosResponse } from 'axios'

class DocumentsService {

    constructor(private apiVersion: string = 'v1') {
    }

    public async nfeRequest(filters: IActionDocumentsRequest, paginator?: IPaginator): Promise<any> {
        try {
            const params: URLSearchParams = this.buildParams(paginator, filters)
            return axiosInstance.get(`${this.apiVersion}/nfes`, { params })
                .then((response: AxiosResponse) => response.data)
        } catch (err: any) {
            throw new Error(err.message)
        }
    }

    public async itensNfeRequest(acess_key: string): Promise<any> {
        try {
            return axiosInstance.get(`${this.apiVersion}/nfes/${acess_key}/products`)
                .then((response: AxiosResponse) => response.data)
        } catch (err: any) {
            throw new Error(err.message)
        }
    }

    public async danfe(access_key: string): Promise<any> {
        try {
            return axiosInstance.get(`${this.apiVersion}/nfes/${access_key}/danfe/pdf`, {
                responseType: 'blob'
            })
                .then((response: AxiosResponse) => response.data)
        } catch (err: any) {
            throw new Error(err.message)
        }
    }

    public async cteRequest(filters: IActionDocumentsRequest, paginator?: IPaginator): Promise<any> {
        try {
            const params: URLSearchParams = this.buildParams(paginator, filters)
            return axiosInstance.get(`${this.apiVersion}/ctes`, { params })
                .then((response: AxiosResponse) => response.data)
        } catch (err: any) {
            throw new Error(err.message)
        }
    }

    public async mdfeRequest(filters: IActionDocumentsRequest, paginator?: IPaginator): Promise<any> {
        try {
            const params: URLSearchParams = this.buildParams(paginator, filters)
            return axiosInstance.get(`${this.apiVersion}/mdfes`, { params })
                .then((response: AxiosResponse) => response.data)
        } catch (err: any) {
            throw new Error(err.message)
        }
    }

    /**
     * Method to convert {@link IPaginator} object to {@link URLSearchParams}.
     * @param {IPaginator} [paginator] Paginator settings.
     * @param {IActionDocumentsRequest} [filters] Paginator settings
     * @return {URLSearchParams} Resulting object.
     */
    public buildParams(paginator?: IPaginator, filters?: IActionDocumentsRequest): URLSearchParams {
        const params = new URLSearchParams()
        if (paginator) {

            if (paginator.page) {
                params.append('page', String(paginator.page + 1))
            }

            if (paginator.rows) {
                params.append('limit', String(paginator.rows))
            }
        }

        if (filters) {

            if (filters?.access_key) {
                params.append('access_key', String(filters.access_key))
            }
            if (filters?.start_date) {
                params.append('start_date', String(filters.start_date))
            }
            if (filters?.end_date) {
                params.append('end_date', String(filters.end_date))
            }
            if (filters?.issuer_document) {
                params.append('issuer_document', String(filters.issuer_document))
            }
            /*if (filters?.issuer_corporate_name) {
                params.append('issuer_corporate_name', String(filters.issuer_corporate_name))
            }*/
            if (filters?.recipient_document) {
                params.append('recipient_document', String(filters.recipient_document))
            }
            /*if (filters?.recipient_corporate_name) {
                params.append('recipient_corporate_name', String(filters.recipient_corporate_name))
            }*/
            if (filters?.emitIp) {
                params.append('ip', String(filters.emitIp))
            }
            if (filters?.emitPort) {
                params.append('port', String(filters.emitPort))
            }

        }
        return params
    }
}

const documentsService = new DocumentsService()

export default documentsService
